import React, { useEffect, useState } from "react";
import {

  Container,
  Grid,
  Icon,
  Search,
} from "semantic-ui-react";

import cx from "classnames";
import _ from "lodash";
import Collections from "./List";
import styles from "./Collectionstyles.scss";
import { useSelector } from "react-redux";


export default function UserManagement({ account, setGoBackPath }) {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [sort, setSort] = useState("first_name");
  const [order, setOrder] = useState("ASC");

  const [query, setQuery] = useState(null);
  const [type, setType] = useState("ALL");
  const permissionData = useSelector((state) => _.get(state, "users.me.role"));


  useEffect(() => {
    setGoBackPath("/");
  }, []);


  const onSearchChange = (e) => {
    let value = e.target.value;
    if (!value) {
      setQuery(value);
    }

    setSearchText(value);
  };

  const onSearchClick = (e) => {
    e.preventDefault();
    setQuery(searchText);
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    setQuery(searchText);
  };





  return (
    <>
      <Container className={cx(styles.container)}>
        <Grid>
          <Grid.Row columns={2} className={cx(styles.tabs)}>

            <Grid.Column width={6} floated="right" textAlign="right">
              <form onSubmit={onSearchSubmit} className={cx(styles.search)}>
                <Search
                  id="search"
                  input={{
                    icon: (
                      <Icon circular name="search" onClick={onSearchClick} />
                    ),
                    className: cx(styles.input),
                  }}
                  showNoResults={false}
                  value={searchText}
                  onSearchChange={onSearchChange}
                  placeholder="Search by name or email"
                ></Search>
              </form>
            </Grid.Column>
          </Grid.Row>


        </Grid>


        <Collections
          type={type}
          query={query}
          sort={sort}
          order={order}
          account={account}
          setTotal={setTotal}
          setLoading={setLoading}
          permissionData={permissionData}
        />



      </Container>
    </>
  );
}

